import AdminDashboard from "../components/dashboard-layout";


function AdminDashboardPage() {
  return <AdminDashboard/>;
}

export default AdminDashboardPage;
